module.exports = __webpack_public_path__ + "img/line-chart-down-03.e4c5607d.svg";